import React from "react";
import "./Minimal.css";

const work = [
  { label: "Minni Map",
    meta: "[Product]",
    url: "https://minnimap.com/"
  },
  { label: "Season Six Games",
    meta: "[Product]",
    url: "https://seasonsixgames.com/" 
  },
  { label: "Arena Ambush",
    meta: "[Game]",
    url: "https://arenaambush.seasonsixgames.com/"
  },
  {
    label: "The Yellow Wall-Paper (Film)",
    meta: "[Art direction]",
    url: "https://drive.google.com/file/d/1xW2Ld_x5AJNt3wY8RydLztu7Qbgy544U/view",
  },
  {
    label: "Beacon",
    meta: "[Concept art]",
    url: "https://www.artstation.com/artwork/a0aaGq",
  },
];

const Home = () => (
  <main className="sr-page">
    <ul className="sr-bottom">
      {work.map(({ label, meta, url }) => (
        <li key={label}>
          {url ? (
            <a href={url} target="_blank" rel="noopener noreferrer">
              {label}
            </a>
          ) : (
            label
          )}
          <span className="sr-meta">&nbsp;{meta}</span>
        </li>
      ))}
    </ul>
  </main>
);

export default Home;